import React from 'react';

import { useHubContext } from '@atlassian/company-hub-common/utils';

// 800px is normal width
const GRID_NORMAL_WIDTH = '800px';

// 1000px is wide width
const GRID_WIDE_WIDTH = '1000px';

// 1100px is extra wide width
const GRID_XWIDE_WIDTH = '1100px';

// 1200px is extra wide width
const GRID_XXWIDE_WIDTH = '1200px';

const GRID_NOTE_WIDTH = '480px';

const GRID_FULL_WIDTH = '100%';

export type GridAppearanceTypes =
	| 'xxwide'
	| 'xwide'
	| 'wide'
	| 'normal'
	| 'note'
	| 'full-width'
	| 'none';

export const getContentWidth = (
	appearance: GridAppearanceTypes,
): '100%' | '1200px' | '1100px' | '1000px' | '480px' | '800px' => {
	switch (appearance) {
		case 'xxwide':
			return GRID_XXWIDE_WIDTH;
		case 'xwide':
			return GRID_XWIDE_WIDTH;
		case 'wide':
			return GRID_WIDE_WIDTH;
		case 'note':
			return GRID_NOTE_WIDTH;
		case 'full-width':
			return GRID_FULL_WIDTH;
		default:
			return GRID_NORMAL_WIDTH;
	}
};

export const withBannerBackgroundColor = <P extends object>(
	InnerComponent: React.ComponentType<P & { bannerBackgroundColor: string }>,
) => {
	return (props: P): React.JSX.Element => {
		const hubContext = useHubContext();
		const bannerBackgroundColor = hubContext.branding.colors.primary;

		return <InnerComponent {...props} bannerBackgroundColor={bannerBackgroundColor} />;
	};
};
